/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown> }} Ui_Color_By_Speed_DescInputs */

const en_ui_color_by_speed_desc = /** @type {(inputs: Ui_Color_By_Speed_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.range} · map + speed chart`)
};

const de_ui_color_by_speed_desc = /** @type {(inputs: Ui_Color_By_Speed_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.range} · Karte + Geschwindigkeits-Chart`)
};

/**
* | output |
* | --- |
* | "{range} · map + speed chart" |
*
* @param {Ui_Color_By_Speed_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_speed_desc = /** @type {((inputs: Ui_Color_By_Speed_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_Speed_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_speed_desc(inputs)
	return de_ui_color_by_speed_desc(inputs)
});